<template>
  <div id="app" :style="extraStyle">
    <div v-if="!isLoginPage" class="top-nav-container">
      <div class="top-nav">
<!--        <div class="top-nav-left">
          <img class="top-nav-logo" src="./assets/images/logoRET.png">
          <router-link v-for="item in menu" :key="item.name" :to="item.path"
                       :class="{'top-nav-menu':true,'top-nav-menu-selected':item===currentMenu}">{{item.name}}</router-link>
        </div>-->
        <!-- 遍历菜单 -->
        <div class="top-nav-left">
<!--          <img class="top-nav-logo" src="./assets/images/logoRET.png">-->
          <img class="top-nav-logo" src="./assets/images/logoSDHZ.png">
          <div
              v-for="item in menu"
              :key="item.name"
              :class="{'top-nav-menu1':true,'top-nav-menu-selected1':item===currentMenu}"
              @mouseenter="showSubMenu(item)"
              @mouseleave="hideSubMenu(item)"
          >
            <!-- 主菜单 -->
            <a v-if="item.blank" href="javascript:void(0);"
               :class="{'top-nav-menu': true, 'top-nav-menu-selected': item === currentMenu}"
               @click.prevent="openUrl(item)"
            >
              {{ item.name }}
            </a>
            <router-link v-else-if="!(item.children && item.children.length>0)" :to="item.path" :class="{'top-nav-menu': true, 'top-nav-menu-selected': item === currentMenu}">
            {{ item.name }}
            </router-link>
            <a v-else href="javascript:void(0);"  @click.prevent="openUrl(item)"
               :class="{'top-nav-menu': true, 'top-nav-menu-selected': item === currentMenu}"

            >
            {{ item.name }}
            </a>
            <!-- 子菜单  @click.prevent="toggleSubMenu(item)" -->
            <div v-if="item.children && item.showSubMenu" class="sub-menu">
              <div
                  v-for="subItem in item.children"
                  :key="subItem.name"
                  :to="subItem.path"
                  class="sub-menu-item-wrapper"
              >
                <!-- 子菜单 -->
                <a v-if="subItem.blank" href="javascript:void(0);"
                   @click.prevent="openUrl(subItem)"  class="sub-menu-item"
                >
                  {{ subItem.name }}
                </a>
                <router-link v-else
                    :key="subItem.name"
                    :to="subItem.path"
                    class="sub-menu-item"
                >
                  {{ subItem.name }}
                </router-link>
              </div>
            </div>
          </div>
          </div>
        <div class="top-nav-right">
          中文 | <span class="eng_color">英文</span>
        </div>

        <div class="top-nav-right" v-if="username">
          {{username}}
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout" divided>退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="user-register-div" v-else>
          <div class="user-register" @click="openDialog">用户注册</div>
        </div>
      </div>
    </div>
    <div class="top-sub-nav" v-if="!isLoginPage &&currentMenu&&currentMenu.subMenu">
      <router-link v-for="item in currentMenu.subMenu" :key="item.name" :to="item.path" class="top-sub-nav-link">{{item.name}}</router-link>
    </div>
    <router-view></router-view>
    <!-- 页面内容 -->
    <float-contact v-if="!isHidden"
        phone="4008123123"
        :miniProgramQrcode="require('@/assets/images/code.png')"
        :wechatQrcode="require('@/assets/images/code.png')"
        :right="0"
        :bottom="'35%'"
        :zIndex="2000"
    />
    <!-- 页面内容 -->
    <float-contact-q v-if="!isHidden"
        phone="4008123123"
        :huizhanQrcode="require('@/assets/images/ss1.png')"
        :right="0"
        :bottom="100"
        :zIndex="2000"
    />
    <!-- 页面内容 -->
    <float-contact-s v-if="!isHidden"
       :jifengQrcode="require('@/assets/images/jifen.png')"
       :yzsQrcode="require('@/assets/images/yzs.png')"
       :left="0"
       :bottom="100"
       :zIndex="2000"
    />
    <div v-if="!isLoginPage" class="footer"></div>
<!--    版权所有 Copyright © 2023-2025 北京融亦投智能科技有限公司-->
    <!-- dialog -->
    <el-dialog
        :title="''"
        :visible.sync="dialogVisible"
        width="700px" append-to-body>
        <img class="user-register-img" src="./assets/images/register-img.png" alt="示例图片" />
    </el-dialog>
  </div>
</template>
<script>
import './echarts/customed'
import FloatContact from '@/components/FloatContact.vue';
import {mapActions, mapState} from "vuex";

import { THEME_KEY } from "vue-echarts";
import FloatContactQ from "./components/FloatContactQ";
import FloatContactS from "./components/FloatContactS";


export default {
  name: 'App',
  provide: {
    [THEME_KEY]: 'customed'
  },
  components: {FloatContactS, FloatContactQ, FloatContact },
  data(){
    return {
      dialogVisible:false,
      menu:[
        {
          name:'首页',
          path:'/home'
        },
        {
          name:'找场馆',
          path:'/changguan/list',
          subMenu:[
            {
              name:'国内场馆综览',
              //path:'/changguan/home'
              path:'/'
            },
            {
              name:'国内场馆',
              path:'/changguan/list'
            },
            {
              name:'境外场馆',
              //path:'/abroadchangguan/list'
              path:'/'
            },
            /*{
              name:'会议酒店',
              path:'/hxe-changguan/list'
            },*/
          ]
        },
        {
          name:'找展会',
          path:'/zhanhui/list',
          subMenu:[
            {
              name:'国内会展综览',
              //path:'/zhanhui/home'
              path:'/'
            },
            {
              name:'国内会展',
              path:'/zhanhui/list'
            },
            {
              name:'国内会议',
              path:'/huiyi/list'
            },
            {
              name:'境外会展',
              path:'/zhanhui/abroad-list'
            },
            {
              name:'境外会议',
              path:'/huiyi/abroad-list'
            },
          ],
          children: [
            {
              name:'展会查询',
              path:'/zhanhui/home',
              blank: false
            },
            {
              name:'视频中心',
              path:'/video-center/home',
              blank: false
            },
            {
              name:'展会文集',
              path:'/meeting-report/home',
              blank: false
            },
            {
              name:'精选商城',
              path:'/shoping/home',
              blank: false
            },
          ],
          showSubMenu: false, // 控制子菜单显示
        },
       /* {
          name:'找展会',
          path:'/zhanhui/home',
          subMenu:[
            {
              name:'国内会展综览',
              path:'/zhanhui/home'
            },
            /!*{
              name:'国内行业会展分析',
              path:'/zhanhui/industry-home'
            },*!/
            {
              name:'国内会展',
              path:'/zhanhui/list'
            },
            {
              name:'国内会议',
              path:'/huiyi/list'
            },
            {
              name:'境外会展',
              path:'/zhanhui/abroad-list'
            },
            {
              name:'境外会议',
              path:'/huiyi/abroad-list'
            },
            {
              name:'视频中心',
              path:'/video-center/home'
            },
            {
              name:'展会文集',
              path:'/meeting-report/home'
            },
            {
              name:'精选商城',
              path:'/shoping/home'
            },

          ]
        },*/
        {
          name:'找服务',
          path:'/service/list',
          subMenu:[
            {
              name:'展会服务',
              path:'/service/list',
            },
            {
              name:'招投标信息',
              path:'/ztbxx/home',
            },
          ],
          children: [
            {
              name:'展会服务',
              path:'/service/list',
              blank: false
            },
            {
              name:'招投标信息',
              path:'/ztbxx/home',
              blank: false
            },
          ],
          showSubMenu: false, // 控制子菜单显示
        },
        {
          name: '找政策',
          path: '/zcxx/list',
          subMenu:[
            {
              name:'政策查询',
              path:'/zcxx/list',
            },
            {
              name:'活动报批',
              //path:'/jlzc/dxzlzx/home',
              path:'/',
            },
            {
              name:'奖补申报',
              path:'/',
            },
          ],
          children: [
            {
              name:'政策查询',
              path:'/zcxx/list',
              blank: false
            },
            {
              name:'活动报批',
              //path:'/jlzc/dxzlzx/home',
              path:'/',
              blank: false
            },
            {
              name:'奖补申报',
              path:'/',
              blank: false
            },
          ],
          showSubMenu: false, // 控制子菜单显示
        },
       /* {
          name:'行业交流',
          path:'/hyjl/home',
        },*/
        {
          name:'产业平台',
          path:'/industry-chat/home',
          subMenu:[
            {
              name:'产业报告',
              path:'/industry-chat/home'
            },
            {
              name:'专业期刊',
              path:'/monthly/home'
            },
          ],
          children: [
            {
              name:'产业报告',
              path:'/industry-chat/home',
              blank: false
            },
            {
              name:'专业期刊',
              path:'/monthly/home',
              blank: false
            },
          ],
          showSubMenu: false, // 控制子菜单显示
        },
       /* {
          name:'找政策',
          path:'/ztb/list',
          subMenu:[
            {
              name:'会展招投标',
              path:'/ztb/list'
            },
            {
              name:'奖励支持',
              path:'/jlzc/all/home'
            },
            /!*{
              name:'政策分析',
              path:'/zcfg/home'
            },*!/
            {
              name:'政策信息',
              path:'/zcxx/list'
            },
            /!*{
              name:'北京奖励支持',
              path:'/jlzc/home'
            },*!/
            {
              name:'展前备案',
              path:'/mof/list'
            },
            /!*{
              name:'经济指标',
              path:'/macro-economy/home'
            },
            {
              name:'统计公报',
              path:'/macro-economy/news'
            },*!/
            {
              name:'一站式服务',
              path:'/one-stop-service/home'
            },
          ]
        },*/
        /*{
          name:'产业图谱',
          path:'/company',
          subMenu:[
            {
              name:'企业综览',
              path:'/company/home'
            },
            {
              name:'企业列表',
              path:'/company/list'
            },
          ]
        },*/
        /*{
          name:'会展招投标',
          path:'/ztb/list'
        },*/
        /*{
          name:'政策法规',
          path:'/zcfg',
          subMenu:[
            {
              name:'政策分析',
              path:'/zcfg/home'
            },
            {
              name:'政策信息',
              path:'/zcfg/list'
            },
          ]
        },*/
        /*{
          name:'行业研报',
          path:'/report',
          subMenu:[
            {
              name:'国内研报',
              path:'/report/list'
            },
            {
              name:'UFI研报',
              path:'/report/ufilist'
            },
            {
              name:'领域报告',
              path:'/report/speciallist'
            }
          ]
        },*/
        /*{
          name:'展前备案',
          path:'/mof/list'
        },*/
        /*{
          name:'宏观经济',
          path:'/macro-economy',
          subMenu:[
            {
              name:'经济指标',
              path:'/macro-economy/home'
            },
            {
              name:'统计公报',
              path:'/macro-economy/news'
            }
          ]
        },*/
       /* {
          name:'展会出海',
          path:'/zhuanti/home',
        },*/
        /*{
          name:'热点专题',
          path:'/zhuanti/home',
          children: [
            { name: '展会出海', path: '/zhuanti/home' },
          ],
          showSubMenu: false, // 控制子菜单显示
        },*/
        /*{
          name:'会展小智',
          path:'/vannaai/home',
        },*/
        /*{
          name:'商城',
          path:'/beijing-gift/home',
          subMenu:[
            {
              name:'北京礼物',
              path:'/beijing-gift/home'
            },
            {
              name:'展会商品',
              path:'/event/home'
            },
            {
              name:'热卖榜单',
              path:'/hot-rank/home'
            },
          ]
        },*/
       /* {
          name:'商城',
          path:'/shoping/home',
        },*/
        /*{
          name:'积分商城',
          path:'/points-mall/home',
        },
        {
          name:'一站式申报服务',
          path:'/jlzc/dxzlzx/home',
        },*/
      ]
    }
  },
  computed: {
    ...mapState(['username','checkedMenu']),
    extraStyle () {
      if (this.$route.path.startsWith('/excerpt') || this.$route.path.startsWith('/memorabilia')) {
        return {paddingLeft: 0}
      } else {
        return null
      }
    },
    currentMenu(){
      for(const menu of this.menu){
        if(menu.path===this.$route.path){
          return menu
        }
        if(menu.subMenu&&menu.subMenu.some(i=>i.path===this.$route.path)){
          return menu
        }
      }
      return null
    },
    isLoginPage() {
      return this.$route.path === '/login';
    },
    isHidden() {
      return this.$route.path === '/jlzc/ljbl/home' || this.$route.path === '/jlzc/hdsblv/home' || this.$route.path ==='/login';
    }
  },
  methods: {
    ...mapActions(['loginUser', 'logoutUser']),  // 将action映射到组件的methods中
    toggleSubMenu(item) {
      // 切换子菜单显示状态
      item.showSubMenu = !item.showSubMenu;
    },
    openUrl(item){
      // 使用 vue-router 进行内部路由跳转，并打开新标签页
      const url = this.$router.resolve({ path: item.path }).href;
      // 拼接上基础的域名
      const baseUrl = window.location.origin;  // 获取当前页面的域名部分
      const fullUrl = baseUrl + url;  // 拼接完整的 URL
      // 使用 URLSearchParams 添加查询参数
      const urlWithParams = new URL(fullUrl);
      if (item.type){
        urlWithParams.searchParams.set('type', item.type);  // 添加 type=1 参数
      }
      // 打开新标签页
      window.open(urlWithParams.href, '_self');
    },
    // 显示子菜单
    showSubMenu(item) {
      if (item.children) {
        item.showSubMenu = true;
      }
    },
    // 隐藏子菜单
    hideSubMenu(item) {
      if (item.children) {
        item.showSubMenu = false;
      }
    },
    handleCommand(command) {
      console.log(command)
      if (command === 'manage') {
        this.$router.push('/system/management');
      } else if (command === 'logout') {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("userId");
        this.logoutUser();  // 调用logoutUser action，清除用户状态并登出
        this.$router.push({ path: '/login' });
      }
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    }
  },
}
</script>
<style>
  #app{
    height: 100%;
    width: 100%;
    /*padding-left: calc(100vw - 100%);*/
    box-sizing: border-box;
    font-size: 16px;
    background-color: #F5F5F5;
  }
  /* 主菜单样式 */
  .top-nav-menu1 {
    position: relative;
    cursor: pointer;
  }
  /* 父级 div 作为容器 */
  .sub-menu-item-wrapper {
    padding: 0px 0; /* 上下间距 */
  }
  /* 仅作用于非最后一个子项 */
  .sub-menu-item-wrapper:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
  .sub-menu-item:not(:last-child) {
    border-bottom: 1px solid #ccc; /* 添加横线，排除最后一个子菜单项 */
  }
  /* 子菜单容器 */
  .sub-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
  }
  /* 子菜单项样式 */
  .sub-menu-item {
    position: relative;
    cursor: pointer;
    padding: 10px 0px;
    color: #333;
    text-decoration: none;
    white-space: nowrap;
    margin: 0px 15px;
    display: block;         /* 确保每个子菜单项都在新的一行 */
  }
  .sub-menu-item:hover {
    color: #007bff;
  }
  /* 鼠标悬停时的主菜单选中状态 */
  .top-nav-menu-selected1 {
    color: #007bff;
  }
  .el-icon-arrow-down{
    color: #FFFFFF;
  }
  .user-register-div{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .user-register{
    color: #ffffff;
    font-size: 12px;
    background: #439ED8;
    border-radius: 4px;
    padding: 10px;
  }
  .user-register-img{
    width: 643px;
    height: 548px;
  }
  .eng_color{
    color: #9F9F9F;
    margin-left: 4px;
  }
</style>
